import { Box, Button, Grid2, Paper } from "@mui/material";
import * as React from "react";
import logosTefl from "../images/logoToefl.png";
import banne3 from "../images/bannerTraduccion.png";
import Typography from "@mui/material/Typography";
import info from "../images/info.png";
import test from "../images/test.png";
import agendar from "../images/agendar.png";
import cursos from "../images/cursos.png";
import images from "../images/images.jpeg";
import TraduccionLista from "../components/TraduccionLista";
import Simultaneo from "../components/Simultaneo";
import Carrousel from "../components/Carrousel";
import { Helmet } from "react-helmet-async";

function Traducciones() {
  return (
    <>
      <Helmet>
        <title> DLS - Traducciones</title>

        <meta
          name="description"
          content="DLS es la única empresa de traducciones en Bolivia, nuestro equipo de traductores cuenta con una amplia experiencia en el campo de traducciones escritas y servicios de interpretación simultánea."
        />
        <meta
          name="keywords"
          content="direccion, bolivia, La Paz, Cochabamba, Santa Cruz, traductor, traduccion, oficial"
        />
        <meta name="author" content="DLS" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <link rel="icon" href="/favicon.ico" />

        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="DLS: Somos la única empresa de traducciones en Bolivia."
        />
        <meta
          property="og:description"
          content="DLS es la única empresa de traducciones en Bolivia, nuestro equipo de traductores cuenta con una amplia experiencia en el campo de traducciones escritas y servicios de interpretación simultánea."
        />
        <meta
          property="og:image"
          content="https://dls.com.bo/static/media/logo_DLS.6424b652d76d8584dbc3.png"
        />
        <meta
          property="og:url"
          content="http://localhost:3000/#/traducciones"
        />

        <link rel="canonical" href="https://dls.com.bo" />
      </Helmet>
      <Box
        sx={{
          width: "auto",
          display: "block",
          textAlign: "justify",
        }}
      >
        <Box>
          <Grid2 container spacing={0}>
            <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  background: "#009999",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={banne3}
                  alt="Digital Language Services"
                  className="animate__animated animate__fadeInLeft img-dim-banner"
                />
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
              <Box
                sx={{
                  background: "#009999",
                  display: "flex",
                  width: "100%",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    background: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                    padding: "20px 0",
                    clipPath: {
                      xs: "none",
                      sm: "none",
                      md: "polygon(10% 0, 100% 0, 100% 100%, 0% 100%)",
                    },
                  }}
                >
                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: {
                        xs: "25px",
                        sm: "35px",
                        md: "30px",
                      },
                      color: "#009999",
                      fontWeight: "bold",
                    }}
                  >
                    TRADUCCIONES OFICIALES
                  </Typography>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Box>
        <Box
          sx={{
            width: {
              xs: "98vw",
              sm: "90vw",
              md: "100vw",
            },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            padding: "2px",
          }}
        >
          <Box
            sx={{
              maxWidth: {
                xs: "98vw",
                sm: "90vw",
                md: "70vw",
              },
              display: "block",
              padding: "2px",
            }}
          >
            <Box sx={{ display: "block" }}>
              <Box
                sx={{
                  display: "block",
                  justifyContent: "center",
                }}
              >
                <Carrousel />
              </Box>
              <Box sx={{ width: "100%", display: "flex" }}>
                <Grid2 container>
                  <Grid2 size={{ sx: 12, sm: 12, md: 12 }}>
                    <Box
                      sx={{
                        display: "block",
                        padding: "25px",
                      }}
                    >
                      <Typography>
                        DLS es la única empresa de traducciones en Bolivia,
                        nuestro equipo de traductores cuenta con una amplia
                        experiencia en el campo de traducciones escritas y
                        servicios de interpretación simultánea. Proporcionamos
                        traducciones precisas y efectivas a personas y empresas
                        para todo tipo de documentos.
                        <br />
                        Los clientes confían en nosotros porque entendemos su
                        industria o actividad, utilizamos una terminología
                        exacta y consistente, entregamos las traducciones a
                        tiempo y dentro del presupuesto.
                      </Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={{ sx: 12, sm: 12, md: 4 }}></Grid2>
                </Grid2>
              </Box>
              <Box sx={{ display: "flex", paddingTop: "35px" }}>
                <TraduccionLista />
              </Box>
              <Box paddingTop={5}>
                <Typography h3 sx={{ fontSize: "22px", padding: "15px 0" }}>
                  <b>¿QUE ES UNA TRADUCCION OFICIAL?</b>
                </Typography>
                <Typography>
                  Traducir es producir un texto con significado equivalente en
                  otro idioma, las traducciones oficiales de documentos son
                  aquellos que llevan firma y sello de un traductor reconocido
                  por un organismo o institución oficial, en el caso de DLS
                  nuestros traductores están reconocidos por las embajadas
                  Británica y de Estados Unidos en Bolivia. Esto permite que las
                  traducciones que sellamos y emitimos son válidas en cualquier
                  país del mundo. Véase Jaime Daniel Romano o Emma Roxana Romano
                  a través de los siguientes links:
                  <br />
                  <Box sx={{ padding: "15px" }}>
                    <Button
                      variant="contained"
                      color="secondary"
                      href="https://bo.usembassy.gov/wp-content/uploads/sites/16/2024/09/TRANSLATORS-LPZ-CBB-SRZ-Master-List.pdf"
                      target="_blank" // Opcional: Abre el enlace en una nueva pestaña
                    >
                      EMBAJADA AMERICANA
                    </Button>
                  </Box>
                  <br />
                  <Box sx={{ padding: "15px" }}>
                    <Button
                      variant="contained"
                      color="secondary"
                      href="https://www.gov.uk/government/publications/list-of-translators-la-paz/bolivia-translators-and-interpreters"
                      target="_blank" // Opcional: Abre el enlace en una nueva pestaña
                    >
                      SITIO OFICIAL - EMBAJADA BRITANICA
                    </Button>
                  </Box>
                  Ciertos documentos antes de ser traducidos requieren contar
                  con una legalización del país de origen, en tal caso antes de
                  traducirse corresponden ser apostillados.
                </Typography>
                <Typography sx={{ fontSize: "22px", padding: "15px 0" }}>
                  <b>¿Qué es y para qué sirve la Apostilla de La Haya?</b>
                </Typography>
                <Typography>
                  La apostilla de La Haya es un método simplificado de
                  legalización de documentos, sirve para que los documentos de
                  carácter legal emitidos en un país sean reconocidos de manera
                  automática en otro Estado. Físicamente La Apostilla, consiste
                  en una hoja que se coloca sobre el documento cuya autenticidad
                  se quiere hacer constar. ¿Cómo apostillar un documento en
                  Bolivia? Se apostillan “documentos públicos en instalaciones
                  de Cancillería en La Paz, Cochabamba y Santa Cruz”, o “en las
                  instituciones donde emiten los documentos”. También puede
                  realizarse la solicitud de una Apostilla Digital a través del
                  siguiente link &nbsp;
                  <Button
                    variant="outlined"
                    href="https://apostilla.rree.gob.bo/#/solicitud"
                    color="secondary"
                    target="_blank"
                  >
                    {" "}
                    Apostilla Digital
                  </Button>
                  &nbsp;(Fuente: Ministerio de Relaciones Exteriores de Bolivia)
                </Typography>
                <Typography sx={{ fontSize: "22px", padding: "15px 0" }}>
                  <b>
                    Servicios Notariales en Embajada de Estados Unidos en
                    Bolivia
                  </b>
                </Typography>
                <Typography>
                  Estos servicios se aplican a los documentos bolivianos que
                  requieren ser certificados en la Sección Consular de la
                  Embajada para su uso en los Estados Unidos o aquellos
                  documentos de ciudadanos bolivianos con residencia en Estados
                  Unidos que requieran realizar trámites en nuestro país.
                </Typography>
                <Typography sx={{ fontSize: "22px", padding: "15px 0" }}>
                  <b>SERVICIOS DLS EN EMBAJADA</b>
                </Typography>
                <ul>
                  <li>
                    <b> 1er Paso:</b> traducción de los documentos por el
                    traductor DLS
                  </li>
                  <li>
                    <b>2do Paso:</b> Presentación de los documentos originales
                    más la traducción en embajada mediante cita previa
                  </li>
                  <li>
                    <b>3er Paso:</b> Notarización por el funcionario de la
                    Embajada quien anexará un Certificado de Reconocimiento
                    debidamente sellado y firmado. (Véase tambien:&nbsp;
                    <Button
                      variant="outlined"
                      href="https://bo.usembassy.gov/es/consular-services-es/notarials-es/"
                      color="secondary"
                      target="_blank"
                    >
                      {" "}
                      Costos de Notarización
                    </Button>
                    &nbsp;)
                  </li>
                </ul>
                <Typography sx={{ fontSize: "22px", padding: "15px 0" }}>
                  <b>INTERPRETACIONES SIMULTANEAS</b>
                </Typography>
                <Typography>
                  DLS cuenta con un eficiente equipo de intérpretes que traducen
                  en otro idioma en tiempo real o en simultáneo de manera
                  presencial o remota.
                </Typography>
                <Typography sx={{ fontSize: "22px", padding: "15px 0" }}>
                  <b>Eventos que el equipo DLS traduce en simultáneo:</b>
                </Typography>
              </Box>
              <Box sx={{ display: "flex", paddingTop: "35px", width: "auto" }}>
                <Simultaneo />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default Traducciones;
